/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_RequiredInputs */

const en_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action Required`)
};

const es_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acción requerida`)
};

const fr_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action requise`)
};

const de_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handlung erforderlich`)
};

const ja_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対応が必要です`)
};

const zh_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要操作`)
};

const ar_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إجراء مطلوب`)
};

const id_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tindakan Diperlukan`)
};

const it_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Azione Richiesta`)
};

const ru_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется действие`)
};

const pt_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ação Necessária`)
};

const ko_action_required = /** @type {(inputs: Action_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조치 필요`)
};

/**
* | output |
* | --- |
* | "Action Required" |
*
* @param {Action_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const action_required = /** @type {((inputs?: Action_RequiredInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_RequiredInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_required(inputs)
	if (locale === "es") return es_action_required(inputs)
	if (locale === "fr") return fr_action_required(inputs)
	if (locale === "de") return de_action_required(inputs)
	if (locale === "ja") return ja_action_required(inputs)
	if (locale === "zh") return zh_action_required(inputs)
	if (locale === "ar") return ar_action_required(inputs)
	if (locale === "id") return id_action_required(inputs)
	if (locale === "it") return it_action_required(inputs)
	if (locale === "ru") return ru_action_required(inputs)
	if (locale === "pt") return pt_action_required(inputs)
	return ko_action_required(inputs)
});